import { render, waitFor } from '@testing-library/react';
import userEvent from '@testing-library/user-event';
import React from 'react';

import Form from './Form';

describe('Form', () => {
  const renderForm = (props) => render(<Form {...props} />);
  const onSuccessEmailChanged = jest.fn();
  const props = {
    dealer: {
      portalName: 'Portal Name',
      email: 'email@email.com',
      owner: {
        name: 'Location Name',
      },
    },
    csrfToken: '<token>',
    onSuccessEmailChanged,
  };

  afterEach(() => {
    jest.restoreAllMocks();
  });

  it('renders the component', () => {
    const { container } = renderForm(props);
    expect(container).toMatchSnapshot();
  });

  describe('when all fields are valid', () => {
    let container;
    let getByRole;
    let getByText;
    let button;

    beforeEach(async () => {
      global.fetch = jest.fn().mockResolvedValue({
        json: () =>
          Promise.resolve({
            valid: true,
          }),
      });

      ({ container, getByRole, getByText } = renderForm(props));

      userEvent.type(
        container.querySelector('input[name="first_name"]'),
        'Jon',
      );
      userEvent.type(container.querySelector('input[name="last_name"]'), 'Doe');
      userEvent.type(
        container.querySelector('input[name="password"]'),
        'abc123@A',
      );

      await waitFor(() => {
        button = getByRole('button', { name: 'Continue' });
        expect(button).not.toBeDisabled();
      });
    });

    it('renders the component', () => {
      expect(container).toMatchSnapshot();
    });

    describe('when clicking the button responds with success', () => {
      beforeEach(() => {
        global.fetch = jest.fn().mockResolvedValue({ ok: true });
      });

      it('send request to backend to save user data', () => {
        userEvent.click(button);

        expect(fetch).toHaveBeenCalledWith(
          '/vendors/update_user',
          expect.anything(),
        );
      });

      describe('when user changed his email', () => {
        it('calls onSuccessEmailChanged callback', async () => {
          const inputElement = container.querySelector('input[name="email"]');
          userEvent.clear(inputElement);
          userEvent.type(inputElement, 'newEmail@email.com');
          userEvent.click(button);

          await waitFor(() => {
            expect(onSuccessEmailChanged).toHaveBeenCalledWith(
              'newEmail@email.com',
            );
          });
        });
      });

      describe('when user did not change his email', () => {
        let originalLocation;

        beforeAll(() => {
          originalLocation = window.location;
        });

        beforeEach(() => {
          Object.defineProperty(window, 'location', {
            writable: true,
            value: {
              href: 'http://localhost/',
            },
          });
        });

        afterAll(() => {
          window.location = originalLocation;
        });

        it('redirects user to /login path', async () => {
          userEvent.click(button);

          await new Promise(process.nextTick);

          expect(window.location.href).toBe('/login');
        });
      });
    });

    describe('when clicking the button responds with error', () => {
      beforeEach(() => {
        global.fetch = jest.fn().mockResolvedValue({ ok: false });
      });

      it('shows error banner', async () => {
        userEvent.click(button);

        await waitFor(() => {
          expect(
            getByText((content, element) => {
              return content.includes('Something went wrong');
            }),
          ).toBeInTheDocument();
        });
      });
    });
  });

  describe('when email is invalid', () => {
    it('renders the component', async () => {
      global.fetch = jest.fn().mockResolvedValue({
        json: () =>
          Promise.resolve({
            valid: false,
            message: 'Invalid email.',
          }),
      });

      const { container, getByText } = renderForm(props);

      await waitFor(() => {
        expect(getByText('Invalid email.')).toBeInTheDocument();
      });

      expect(container).toMatchSnapshot();
    });
  });
});
